import {
  GetEmployeesSalaryRangesConformanceDocument,
  GetEmployeesSalaryRangesConformanceQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type Return = NonNullable<
  GetEmployeesSalaryRangesConformanceQuery['jobCatalog']['employeesSalaryRangesConformances']
>[number]

export const useEmployeesSalaryRangesConformance = (
  ids: string[]
): [Return | null | undefined, boolean] => {
  const { data, loading } = useQuery(GetEmployeesSalaryRangesConformanceDocument, {
    variables: { ids },
  })

  return [data ? data?.jobCatalog.employeesSalaryRangesConformances[0] : null, loading]
}
